import { Card, CardContent } from "../components/ui/card";
import { Map, FileText, Users, Calendar } from "lucide-react";

const CementerioPage = () => {
  const modules = [
    { title: "Parcelas", description: "Gestión de parcelas y espacios", icon: Map, color: "stone" },
    { title: "Servicios", description: "Servicios funerarios municipales", icon: FileText, color: "slate" },
    { title: "Titulares", description: "Registro de titulares y beneficiarios", icon: Users, color: "zinc" },
    { title: "Programación", description: "Agenda de servicios", icon: Calendar, color: "gray" }
  ];

  return (
    <div className="space-y-6" data-testid="cementerio-page">
      {/* Header */}
      <div className="flex items-center gap-4">
        <div className="w-12 h-12 bg-stone-100 rounded-xl flex items-center justify-center">
          <Map className="w-6 h-6 text-stone-600" />
        </div>
        <div>
          <h1 className="text-2xl font-bold text-slate-900" style={{ fontFamily: 'Manrope, sans-serif' }}>
            Cementerio Municipal
          </h1>
          <p className="text-slate-500">Gestión del cementerio municipal</p>
        </div>
      </div>

      {/* Module Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {modules.map((module, index) => {
          const Icon = module.icon;
          return (
            <Card key={index} className="card-hover cursor-pointer group" data-testid={`cementerio-module-${index}`}>
              <CardContent className="p-6">
                <div className={`w-12 h-12 bg-${module.color}-100 rounded-lg flex items-center justify-center mb-4 group-hover:scale-110 transition-transform`}>
                  <Icon className={`w-6 h-6 text-${module.color}-600`} />
                </div>
                <h3 className="font-semibold text-slate-900 mb-1">{module.title}</h3>
                <p className="text-sm text-slate-500">{module.description}</p>
              </CardContent>
            </Card>
          );
        })}
      </div>

    </div>
  );
};

export default CementerioPage;
